<template lang="pug">
  b-modal#updateMemberBetLimit(
  ref="updateMemberBetLimit"
  :title="$t('ui.combine.update_member_bet_limit')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success")
      b-form-group(:label="$t('ui.account_id')" disabled).mb-3
        DebounceInput(
          size="sm"
          ref="account_id"
          required
          alphaNum
          type="text"
          :dirty="$v.account_id.$dirty"
          :error="$v.account_id.$error"
          v-model.trim.lazy="$v.account_id.$model"
          :disabled="loading"
          :maxLength="$v.account_id.$params.maxLength.max"
        )
        ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")
      b-form-group.mb-3
        div.row.mb-3.animated.fadeIn
          div.col
            table.tablex(style="width: 100%;")
              thead
                tr
                  th.sticky-position(width="3%")
                    span #
                  th.sticky-position(width="9%")
                    span(:title="$t('ui.provider_name')") {{ $t("ui.provider_name") }}
                  th.sticky-position(width="8%")
                    span(:title="$t('ui.package')") {{ $t("ui.package") }}
              tbody
                tr(v-if="mergeList.length == 0")
                  td(colspan="3").text-center
                    span {{ $t('message.no_data_available') }}
                tr(v-for="(item, index) in mergeList")
                  td
                    span(:title="index + 1") {{ index + 1 }}
                  td
                    span(:title="item.provider_name") {{ item.provider_name }}
                  td
                    b-form-select(
                      size="sm"
                      :value="item.package"
                      :class="item.provider_code"
                      :disabled="loading"
                      @change="changeBetLimit(item, $event, item.package)"
                      )
                      option(value="" disabled selected) {{ $t("message.select_option") }}
                      option(v-for="option in options" :value="option.value") {{ option.text }}
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, email, sameAs } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import $ from 'jquery';

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      account_id: '',
      loading: false,
      betLimitList: [],
      providerBetLimitList: [],
      feedback: {
        success: true,
        status: ""
      },
      options: [
        {
          value: "A",
          text: "A"
        },
        {
          value: "B",
          text: "B"
        },
        {
          value: "C",
          text: "C"
        }
      ]
    };
  },
  computed: {
    mergeList() {
      var tempProviderList = this.providerBetLimitList;
      var tempMemberList = this.betLimitList;
      var list = [];

      for(var i = 0; i < tempProviderList.length; i++) {
        var temp = tempMemberList.filter(item => { return item.provider_code == tempProviderList[i].provider_code });
        list.push({
          provider_code: tempProviderList[i].provider_code,
          provider_name: tempProviderList[i].provider_name,
          package: temp.length > 0 ? temp[0].package : '',
        });
      }

      return list;
    }
  },
  validations: {
    account_id: {
      required,
      alphaNum,
      maxLength: maxLength(20)
    }
  },
  methods: {
    changeBetLimit(info, eventStatus, orgvalue) {
      this.$helpers
        .alert({
          title: this.$t("ui.bet_limit"),
          text: this.$t("message.change_member_bet_limit_confirm", { name: this.account_id, provider: info.provider_name }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmChangeBetLimit(info, eventStatus);
          } else {
            // console.log(orgvalue)
            $("." + info.provider_code).val(orgvalue);
          }
        });
    },
    confirmChangeBetLimit: function(info, value) {
      let url = config.betLimitMemberUpdateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.account_id,
        provider_code: info.provider_code,
        package: value,
        audit_by: this.$store.getters.loginId,
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.combine.update_member_bet_limit"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                //this.$emit("failed", "update_profile", this.feedback.status);
                // this.$refs.updateMemberBetLimit.hide();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getProviderBetLimitList: function() {
      let url = config.betLimitProviderListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.providerBetLimitList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getBetLimitMemberList: function() {
      let url = config.betLimitMemberListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        member_id: this.item.account_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.betLimitList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.account_id = this.item.account_id;
      this.getProviderBetLimitList();
      this.getBetLimitMemberList();
    }
  }
};
</script>
